const initialState = {
  IsQualityAssuranceDataLoaded: '',
  newQualityAssurance: false,
  //QualityAssuranceReviewId: '',
  reviewDate: '',
  lastReviewDate: '',
  nextReviewDate: '',
  question1: '',
  question2: '',
  question3: '',
  question4: '',
  question5: '',
  question6: '',
  question7: '',
  question8: '',
  question9: '',
  question10: '',
  question11: '',
  question13: '',
  question14: '',
  question15: '',
  exceptionComments: '',
  followUpComments: '',
  dateCreated: '',
  dateEdited: '',
  reviewCreatedBy: {
    id: '',
    value: '',
  },
  editedBy: {
    id: '',
    value: '',
  },
};

export default initialState;
